const user = {
    state: {
        userInfo: {
            uid: 'LongMao-User',
            nickname: 'LongMao-User',
            headimg: 'http://pic.51yuansu.com/pic3/cover/01/69/80/595f67c3a6eb1_610.jpg',
            wx_bind: 0,
            member_wx_bind: 0,
        },
        token: null,
        refresh: null
    },
    getters: {
        token: (state) => {
            return state.token
        },
        userInfo: (state) => {
            return state.userInfo
        }
    },
    mutations: {
        changeUser(state, user) {
            state.userInfo = user;
        },
        changeToken(state, token, refresh) {
            state.token = token
            state.refresh = refresh
        }
    }
}

export default user


// WEBPACK FOOTER //
// ./src/store/modules/user.js